import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import PlatformOptions from "@/pages/PlatformOptions";
import AAOptions from "@/pages/AAOptions";
import ProofOptions from "@/pages/ProofOptions";
import FontOptions from "@/pages/FontOptions";
import TrismOptions from "@/pages/TrismOptions";
import FunctionsOptions from "@/pages/FunctionsOptions";
import FunctionsNavOptions from "@/pages/FunctionsNavOptions";
import JourneyOptions from "@/pages/JourneyOptions";
import DemoThumbOptions from "@/pages/DemoThumbOptions";
import HireBlockOptions from "@/pages/HireBlockOptions";
import HireBlockOptions2 from "@/pages/HireBlockOptions2";
import DemoThumbBottomOptions from "@/pages/DemoThumbBottomOptions";
import DemoThumbBottomOptions2 from "@/pages/DemoThumbBottomOptions2";
import SectionLayoutOptions from "@/pages/SectionLayoutOptions";
import SectionLayoutSwitched from "@/pages/SectionLayoutSwitched";
import RailActiveOptions from "@/pages/RailActiveOptions";
import EnterpriseBrainOptions from "@/pages/EnterpriseBrainOptions";
import CapabilityCardOptions from "@/pages/CapabilityCardOptions";
import RailBalanceOptions from "@/pages/RailBalanceOptions";
import CaseStudyOptions from "@/pages/CaseStudyOptions";
import CaseStudyOptions2 from "@/pages/CaseStudyOptions2";
import CaseStudyOptions3 from "@/pages/CaseStudyOptions3";
import CaseStudyOptions4 from "@/pages/CaseStudyOptions4";
import CaseStudyOptions5 from "@/pages/CaseStudyOptions5";
import CaseStudyOptions6 from "@/pages/CaseStudyOptions6";
import CommitmentsPreview, { CommitmentsA, CommitmentsB, CommitmentsC } from "@/pages/CommitmentsPreview";
import CommitmentsPreview2, { CommitmentsD, CommitmentsE, CommitmentsF } from "@/pages/CommitmentsPreview2";
import AAColorOptions from "@/pages/AAColorOptions";
import LeadershipOptions, { LeadershipA, LeadershipB, LeadershipC } from "@/pages/LeadershipOptions";
import LeadershipDark from "@/pages/LeadershipDark";
import LeadershipDark2 from "@/pages/LeadershipDark2";
import ButtonOptions from "@/pages/ButtonOptions";
import NavBgPreview from "@/pages/NavBgPreview";
import HeroVisualPreview from "@/pages/HeroVisualPreview";
import SeparatorPreview from "@/pages/SeparatorPreview";
import HeroVisualOptions from "@/pages/HeroVisualOptions";
import Resources from "@/pages/Resources";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nav-bg-preview" element={<NavBgPreview />} />
          <Route path="/hero-visual-preview" element={<HeroVisualPreview />} />
          <Route path="/separator-preview" element={<SeparatorPreview />} />
          <Route path="/platform-options" element={<PlatformOptions />} />
          <Route path="/aa-options" element={<AAOptions />} />
          <Route path="/proof-options" element={<ProofOptions />} />
          <Route path="/font-options" element={<FontOptions />} />
          <Route path="/trism-options" element={<TrismOptions />} />
          <Route path="/functions-options" element={<FunctionsOptions />} />
          <Route path="/functions-nav-options" element={<FunctionsNavOptions />} />
          <Route path="/journey-options" element={<JourneyOptions />} />
          <Route path="/demo-thumb-options" element={<DemoThumbOptions />} />
          <Route path="/hire-block-options" element={<HireBlockOptions />} />
          <Route path="/hire-block-options-2" element={<HireBlockOptions2 />} />
          <Route path="/demo-thumb-bottom-options" element={<DemoThumbBottomOptions />} />
          <Route path="/demo-thumb-bottom-options-2" element={<DemoThumbBottomOptions2 />} />
          <Route path="/section-layout-options" element={<SectionLayoutOptions />} />
          <Route path="/section-layout-switched" element={<SectionLayoutSwitched />} />
          <Route path="/rail-active-options" element={<RailActiveOptions />} />
          <Route path="/enterprise-brain-options" element={<EnterpriseBrainOptions />} />
          <Route path="/capability-card-options" element={<CapabilityCardOptions />} />
          <Route path="/rail-balance-options" element={<RailBalanceOptions />} />
          <Route path="/case-study-options" element={<CaseStudyOptions />} />
          <Route path="/case-study-options-2" element={<CaseStudyOptions2 />} />
          <Route path="/case-study-options-3" element={<CaseStudyOptions3 />} />
          <Route path="/case-study-options-4" element={<CaseStudyOptions4 />} />
          <Route path="/case-study-options-5" element={<CaseStudyOptions5 />} />
          <Route path="/case-study-options-6" element={<CaseStudyOptions6 />} />
          <Route path="/commitments" element={<CommitmentsPreview />} />
          <Route path="/commit-a" element={<CommitmentsA />} />
          <Route path="/commit-b" element={<CommitmentsB />} />
          <Route path="/commit-c" element={<CommitmentsC />} />
          <Route path="/commitments2" element={<CommitmentsPreview2 />} />
          <Route path="/commit-d" element={<CommitmentsD />} />
          <Route path="/commit-e" element={<CommitmentsE />} />
          <Route path="/commit-f" element={<CommitmentsF />} />
          <Route path="/aa-colors" element={<AAColorOptions />} />
          <Route path="/leadership-options" element={<LeadershipOptions />} />
          <Route path="/lead-a" element={<LeadershipA />} />
          <Route path="/lead-b" element={<LeadershipB />} />
          <Route path="/lead-c" element={<LeadershipC />} />
          <Route path="/leadership-dark" element={<LeadershipDark />} />
          <Route path="/leadership-dark-2" element={<LeadershipDark2 />} />
          <Route path="/button-options" element={<ButtonOptions />} />
          <Route path="/hero-visual-options" element={<HeroVisualOptions />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
